// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";
import * as Effect_Aff_Compat from "../Effect.Aff.Compat/index.js";
var awaitRequest = function (doc) {
    return Effect_Aff_Compat.fromEffectFnAff($foreign.awaitRequestImpl(doc));
};
export {
    awaitRequest
};
//# sourceMappingURL=index.js.map
